<template>
  <b-nav-item-dropdown
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu-media"
      right
  >
    <template #button-content>
      <feather-icon
          :badge="$store.state.ticket.tickets.length"
          badge-classes="bg-danger"
          class="text-body"
          icon="InboxIcon"
          size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          تیک های ورودی
        </h4>
        <b-badge
            pill
            variant="light-primary"
            v-show="$store.state.ticket.tickets.length"
        >
          {{ $store.state.ticket.tickets.length }} جدید
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
    >
      <b-link
          v-for="ticket in $store.state.ticket.tickets"
          :key="ticket.id"
          :to="{name:'Tickets_Detail',params:{id:ticket.parentTicketId}}"
      >
        <b-media>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ ticket.title }}
            </span>
          </p>
          <small class="notification-text">{{ ticket.content }}</small>
        </b-media>
      </b-link>

    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          block
          @click="$router.push({name: 'Tickets_Inbox'})"
      >مشاهده تمام نامه ها
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import store from "@/store";
import {getUserData} from "@/auth/utils";
import { doubleRaf } from '@/libs/utils'


export default {
  name: "TicketsNavBar",
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tickets: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      }
    }
  },
  methods: {
    getTickets() {
      doubleRaf(() =>{
        this.$http.get(`tickets/notification?unseen=1`)
            .then(({data}) => {
              store.commit('ticket/ADD_TICKETS_TO_LIST', data)

            })
      })

    },
   async listen() {
     const router = this.$router
     setTimeout(()=>{
       this.$echo
           .channel(`ticket.${this.$store.state.user.data.id}`)
           .listen('.NewTicketEvent', (data) => {
             const tickets = this.$store.state.ticket.tickets
             tickets.unshift(data)
             store.commit('ticket/ADD_TICKETS_TO_LIST', tickets)

             this.$bvToast.toast(data.title, {
               title: 'نامه جدید',
               variant: 'info',
               toaster: 'b-toaster-top-left'
             })
             this.$notification.show('نامه جدید', {
               body: data.title ?? ''
             }, {
               onclick: function () {
                 router.push({ name: 'Tickets_Detail',params:{'id':data.id} })
               },
             })
           });

     },3000)

    },
  },

  mounted() {
    this.getTickets()
    this.listen()
  }
}
</script>

<style>

</style>
